function handleOpenClick(event: Event): void {
  const dialog = (event.currentTarget as HTMLButtonElement | null)
    ?.closest(".team-bios__item")
    ?.querySelector("dialog");
  if (dialog == null) return;
  dialog.showModal();
}

for (const button of document.querySelectorAll(
  ".team-bios__item__button"
) as NodeListOf<HTMLButtonElement>) {
  button.addEventListener("click", handleOpenClick);
}
